/**
 * Site desenvolvido para divulgação das especializações de odontologia
 *
 * @version 1.0.0
 * @author [Renato Alves](https://github.com/renatociqueira)
 */

import React from "react";
import { Route, BrowserRouter, Switch} from "react-router-dom";

import Home from './Pages/App/Home/Index';
import Endodontia from './Pages/App/Endodontia/index';
import Imaginologia from './Pages/App/Imaginologia';
import Implantodontia from "./Pages/App/Implantodontia";
import Pacientesespeciais from "./Pages/App/Pacientesespeciais";

const Rotas = () => (
        <BrowserRouter>
            <Switch>
                <Route component = { Home }  path="/" exact/>
                <Route component = { Endodontia } path="/endodontia" exact/>
                <Route component = { Imaginologia } path="/imaginologia" exact/>
                <Route component = { Implantodontia } path="/implantodontia" exact/>
                <Route component = { Pacientesespeciais } path="/pacientesespeciais" exact/>
            </Switch>
        </BrowserRouter>
    );

export default Rotas;
